import { render, staticRenderFns } from "./PopFrame.vue?vue&type=template&id=badf911e&scoped=true&"
import script from "./PopFrame.vue?vue&type=script&lang=js&"
export * from "./PopFrame.vue?vue&type=script&lang=js&"
import style0 from "./PopFrame.vue?vue&type=style&index=0&id=badf911e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "badf911e",
  null
  
)

export default component.exports